import { useState } from "react"
import {
  FieldListItemWithValue,
  getDisplayValue,
  Reorderable,
} from "web/components"
import { Input } from "web/components/Form/Controls"
import { handleMoveChildren } from "web/components/Reorderable/ReorderChildrenHelper"
import { snakecase } from "web/services/inflector"
import { TileFieldSelector, TileSizeSelectors } from "web/components/Tiles"
import { RecordContext } from "web/contexts"
import TileWizardActions from "web/components/AddTileWizard/TileWizardActions"
import { displayEmptyValueMessage } from "../SummaryTiles/util"

export function TileSummarySettingsModal({
  backButtonHandler,
  close,
  isTemplate,
  tile,
  tileEntry,
  overview,
}) {
  const [title, setTitle] = useState({ value: tile.name })
  const [tileWidth, setTileWidth] = useState({
    value: tileEntry.width,
  })

  async function handleTileWidthChange(selectedOption) {
    await overview.update({
      [overview.type]: {
        tile_entries_attributes: [
          {
            id: tileEntry.id,
            width: selectedOption.value,
          },
        ],
      },
    })

    setTileWidth(selectedOption)
  }

  function handleMoveField(prevPos, newPos) {
    handleMoveChildren({
      prevPos: prevPos,
      newPos: newPos,
      mainObj: tile,
      movingObjs: tile.fields,
      idName: "tile_field_id",
      firstLayer: "overview_tile",
      secondLayer: "tile_fields_attributes",
    })
  }

  function handleDeleteField(field) {
    tile.update({
      overview_tile: {
        tile_fields_attributes: [
          {
            id: field.tile_field_id,
            _destroy: true,
          },
        ],
      },
    })
  }

  async function handleSave() {
    if (title && title.value && /\S/.test(title.value)) {
      await tile.update({
        overview_tile: { name: title.value.trim() },
      })
    }

    close()
  }

  const showSummarizableMessage =
    tile.data?.summarizable_count && tile.data.summarizable_count > 1

  return (
    <>
      <div className="modal-content-above-commands">
        <div className="mb-4 flex items-end">
          <Input label="Title" value={title} onChange={setTitle} />
        </div>
        <div className="mb-4">
          <TileSizeSelectors
            tileWidth={tileWidth}
            setTileWidth={handleTileWidthChange}
            limitTileSizeOptions={{ width: 2, height: 0 }}
          />
        </div>
        <div className="rounded-md border px-4 py-4 shadow-sm">
          <div className="mb-1 text-lg font-bold">Fields</div>
          <div className="mb-3">
            <TileFieldSelector
              tile={tile}
              subjectType={snakecase(tile.summarizable_type)}
            />
          </div>
          <div className="space-between flex">
            <RecordContext.Provider value={tile.data}>
              <Reorderable
                id="field-set"
                itemListClass={"w-full"}
                itemContainerClass={"cursor-pointer"}
                onMoveItem={handleMoveField}
              >
                {tile.fields.map((field) => {
                  return (
                    <FieldListItemWithValue
                      key={field.id}
                      summaryMethod={
                        showSummarizableMessage && field.summary_method
                      }
                      fieldKey={field.key}
                      handleDeleteField={() => handleDeleteField(field)}
                      label={field.label}
                      value={
                        isTemplate
                          ? { value: field.dummy_value }
                          : getDisplayValue(tile.data, field.key)
                      }
                      summaryMessage={
                        showSummarizableMessage &&
                        displayEmptyValueMessage(tile, field)
                      }
                      showDummyData={isTemplate}
                    />
                  )
                })}
              </Reorderable>
            </RecordContext.Provider>
          </div>
        </div>
      </div>
      <TileWizardActions
        backButtonHandler={backButtonHandler}
        onSaveHandler={handleSave}
      />
    </>
  )
}
